import React from 'react';

import AutocompleteBase from 'components/mui/Form/Autocomplete/AutocompleteBase';

const AutocompleteForm = (props) => {
  const { input, meta, ...rest } = props;
  const isError = Boolean(meta.touched && meta.error);

  return (
    <AutocompleteBase
      onChange={(event, option) => input.onChange(option && option.value)}
      value={input.value}
      error={isError}
      {...rest}
    />
  );
};

export default AutocompleteForm;
